module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAdCAMAAACKeiw+AAAAM1BMVEX////////////////////////////////////////////////////////////////////lEOhHAAAAEHRSTlMAECAwQFBgcICQoLDA0ODwVOCoyAAAAPdJREFUKJFtk8EWxRAMRCcaBHmS///at6AtbWfhHK7KGClwKRZ1d9cS8RKJuUpkjqJuQjvlbhLOSRDrvNLkbdtPzfNKMx7KXm6a3mauxWD1TYFiw0zt9IXRGwCEr6MBgD0AKH3WSDKVj/l5OQcg+qKRW+4A+UhAV6wAgMMD2HHjrCuG844ZyRZs6YnBdmOVB6ayHR7BTjeu9qyNeYu6Om8zFwJ+496H3bSPXMoPQLYZOZ+aocEEAJl8Z548AIDY54uRjarU9Qvr+c7HVz9UPy0gPjoRoLp2wfHoXO62zam5Xj9HVNeAXdzctYgUdW+MtyiJqmpJi48/f/AOagbhEpIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/005-youtube.png
// module id = 207
// module chunks = 4